import type { EmplacementType } from "~/components/ui/Product/ProductHeader/PanelEmbroidery/EmbroideryForm/EmbroideryPlacementSelector/constants"

export function isValidEmplacementType(type: EmplacementType | "none" | null): type is EmplacementType {
  return Boolean(type) && type !== "none"
}
